/**
 * App Config File
 */
export default {
  appLogo: '/static/img/session.svg',                                   // App Logo,
  darkLogo: '/static/img/logo-white.svg',							    // dark logo
  appLogo2: '/static/img/logo-white.svg',                                 // App Logo 2 For Login & Signup Page
  brand: 'Taşın',                                        			        // Brand Name
  copyrightText: 'Taşın © 2020 All Rights Reserved.',                     // Copyright Text
  enableUserTour: false,   // Enable User Tour
  weatherApiId: 'b1b15e88fa797225412429c1c50c122a1',						// weather API Id
  weatherApiKey: '69b72ed255ce5efad910bd946685883a'						// weather APi key
}
